module.exports = __webpack_public_path__ + "static/media/pointsSS.4c962918.png";